(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ugc-band"] && !Shopify.designMode) return;
  try {
    
(function () {
  // querySelectorAll, not querySelector: v3 ships this section on product,
  // collection and About templates too, and a page may hold more than one.
  var bands = document.querySelectorAll('[data-ugc-band]');
  if (!bands.length) return;
  var vids = document.querySelectorAll('[data-ugc-band] video');
  if (!vids.length) return;

  if (!('IntersectionObserver' in window)) {
    vids.forEach(function (v) { if (v.dataset.poster) v.poster = v.dataset.poster; var p = v.play(); if (p && p.catch) p.catch(function () {}); });
    return;
  }

  // One shared observer for every tile. Only well-visible tiles play, so the
  // duplicated groups that sit offscreen never download or decode.
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      var v = e.target;
      if (e.isIntersecting) {
        var p = v.play();
        if (p && p.catch) p.catch(function () {});
      } else if (!v.paused) {
        v.pause();
      }
    });
  }, { threshold: 0.25 });

  vids.forEach(function (v) { io.observe(v); });

  // 2026-09-27 speed pass: posters were full-size files fetched at page load even though the band
  // sits far down the page. They now carry a 540px width and are set only when a tile comes within
  // 800px of the screen. Reverse: data-poster back to poster in the markup and delete this block.
  var pio = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting && e.target.dataset.poster) { e.target.poster = e.target.dataset.poster; pio.unobserve(e.target); }
    });
  }, { rootMargin: '800px' });
  vids.forEach(function (v) { if (v.dataset.poster) pio.observe(v); });
})();

  } catch(e) { console.error(e); }
})();
})();
